// extracted by mini-css-extract-plugin
export default {"dark":"Section_dark__Esv65","section":"Section_section__X4Dam","contentWrap":"Section_contentWrap__gNm8G"};